import { utils, bindPannel, setCartridgeUrl, reloadOrderSummary, checkShippingGroup } from './shipping-utils';
import { inputReexListener } from './shipping-reex';
import { init as initStateButtonsHandler } from '../state-button-handler';
import { getParameters } from '@/customer/customer-utils';

let lastAddressId = null;

function addressId(){
  if(cube.$('.checkout__shipping__home-delivery input[name="delivery-type"]')){
    if(cube.$('.checkout__shipping__home-delivery input[name="delivery-type"]').hasAttribute('disabled')) {
      return cube.$('.checkout__shipping__home-delivery input[name="delivery-type"]').dataset.selectedaddressid;
    }
    return cube.$('.checkout__shipping__home-delivery input[name="delivery-type"]:checked').dataset.selectedaddressid;

  }
  return '';

};

/*
 * Load Address Book
 */
function chooseDelegation(){
  if(cube.$id('bt-choose-address'))
    cube.$id('bt-choose-address').addEventListener('click', choose);
};

function choose(event){

  displayHandler(event.target);

  const params = {
    selectedAddressId : addressId()
  };

  cube.$id('address-book').removeAttribute('data-t-url-actor');

  setCartridgeUrl('checkout.shipping.ch_addressbook', '/content/Shared/Checkout/Checkout Content/AddressBook', 'address-book');

  cube.cartridge('address-book').after(() => {
    changeDelegation();
    removeDelegation();
    backDelegation();
    editDelegation();
    cancelDelegation();
  }).reload(params);
};

/*
 * Prefer Address
 */
function preferDelegation(){
  if(cube.$id('favorite-address'))
    cube.$id('favorite-address').addEventListener('change', prefer);
};

function prefer(event){
  /* eslint-disable one-var */

  const input   = event.target,
    postUrl = 'rest/model/atg/userprofiling/ProfileActor/setAsPreferedAddress',
    params  = {
      addressId : addressId(),
      selected  : true
    };

  cube.ajax.form(postUrl, params)
    .onSuccess(response => {
      errorHandler(response, input);
    })
    .onError(() => cube.alert.error(window.Messages('shipping.error.ajax')))
    .call();

};

/*
 * Remove Address
 */
function removeDelegation(){
  const modal = cube.$id('js-address-book-modal');
  let addressToRemove = null;

  const deleteAddressButtons = cube.$$('.js-remove-address');
  if(deleteAddressButtons){
    deleteAddressButtons.on('click', e => {
      e.preventDefault();
      const removeButton = e.target.closest('.js-remove-address');
      addressToRemove = removeButton && removeButton.dataset ? removeButton.dataset.addressid : false;

      modal.checked = true;
    });
  }
  const modalConfirmationButton   = cube.$id('js-address-book-modal-confirmation');
  if(modalConfirmationButton) {
    modalConfirmationButton.on('click', e => {
      e.preventDefault();
      if(addressToRemove){
        remove(addressToRemove);
      }
    });
  }

  const modalCancelButton   =  cube.$id('js-address-book-modal-cancel');
  if(modalCancelButton) {
    modalCancelButton.on('click', e => {
      modal.checked = false;
    });
  }
};

function remove(address){
  const params = {
    '&addressIdToDelete' : address,
    selectedAddressId : addressId()
  };

  setCartridgeUrl('checkout.shipping.ch_addressbook', '/atg/userprofiling/ProfileActor/deleteShippingAddress-checkout', 'address-book');

  cube.cartridge('address-book').after(() => {
    sucessMessage();
    changeDelegation();
    editDelegation();
    cancelDelegation();
    backDelegation();
    removeDelegation();
    reloadOrderSummary();
    if (params['&addressIdToDelete'] === params.selectedAddressId) {
      if (cube.$$('.js-address-radio').length > 0) {
        const elements = document.getElementsByName('address-choose');
        elements.forEach(elem => {
          elem.checked = false;
        });

        cube.$('.checkout__shipping__input').checked = false;
        reloadOrderSummary();
        setTimeout(() => {
          if ($('body').find('#shippingFees-orde-summary').length) {
            cube.$id('shippingFees-orde-summary').classList.add('hide');
            cube.$class('js-total-with-shipping').forEach(e => e.classList.add('hide'));
            cube.$class('js-total-without-shipping').forEach(e => e.classList.remove('hide'));
          }
        }, 200);
      }
    }
  }).reload(params);
};

/*
 * Close remove address modal
 */
function cancelDelegation(){
  if(cube.$$('.cancel-deletion')) {
    const cancelDeletion = cube.$$('.cancel-deletion');

    cancelDeletion.forEach(element => {
      element.addEventListener('click', closeModal);
    });

  }
};

function closeModal(event){
  event.preventDefault();
  if(cube.$('.modal.in')) {
    cube.$('.modal.in').$('.close-modal').click();
  }
  $('.modal-backdrop').hide();
  $('body').removeClass('modal-open');
};

/*
 * Edit Address
 */
function editDelegation(){
  if(cube.$$('.modify-item')) {
    const editAddress = cube.$$('.modify-item');

    editAddress.forEach(element => {
      element.addEventListener('click', edit);
    });

  }
};

function edit(event){

  event.preventDefault();
  let link = event.target;

  if (link.tagName === 'FONT') {
    link=event.target.closest('a');
  }

  displayHandler(link);

  cube.$id('address-book').removeAttribute('data-t-url-actor');

  setCartridgeUrl('checkout.shipping.ch_shippingaddress', '/content/Shared/Checkout/Shipping Content/ShippingAddress', 'address-book');

  const params = {
    addressId : link.dataset.addressid,
    selectedAddressId : addressId(),
    fromAddressBook : true
  };

  lastAddressId = params.addressId;

  cube.cartridge('address-book').after(() => {
    creationDelegation();
    backDelegation();
    geoCode();
  }).reload(params);
};

/*
 * Change Address
 */
function changeDelegation(){
  const changeAddress = cube.$$('.js-address-radio');

  if(changeAddress) {
    changeAddress.forEach(element => {
      element.addEventListener('click', change);
    });
  }
};

function change(event){

  let currentShippingMethod = cube.$('.checkout__shipping__home-delivery input[name="delivery-type"]:checked');
  let firstShippingMethod = cube.$('.checkout__shipping__home-delivery input[name="delivery-type"]:first-child');


  //check if address is valid
  if(!event.target.closest('.error-address')){
    setCartridgeUrl('ch_shippingcontentslot',
      '/atg/commerce/order/purchase/CreateHardgoodShippingGroupActor/addHardgoodShippingGroup',
      'home-delivery');

      const params = {
        // ⚠️ TODO: ugly hack because the reloadCartridgeFromActor controller don't have the same behavior of other Play controllers
        '&shippingMethodOptionId'      : event.target.closest('.checkout__shipping__store').previousElementSibling.getAttribute('for'),
        selectedAddressId           : event.target.value,
        reloadHomeDeliveryCartridge : true,
        context: cube.$id('home-delivery').dataset.context
      };

    cube.cartridge('home-delivery').before(() => {
    // TODO loader
    }).after(response => {
      errorHandler(response, '');
      chooseDelegation();
      editDelegation();
      preferDelegation();
      if(cube.$('.checkout__shipping__home-delivery input[name="delivery-type"]')) {
        if (currentShippingMethod && currentShippingMethod.id !== firstShippingMethod.id && cube.$id(currentShippingMethod.id)) {
          currentShippingMethod = cube.$id(currentShippingMethod.id);
          currentShippingMethod.click();
          currentShippingMethod.dispatchEvent(new CustomEvent('change'));
        } else {
          firstShippingMethod = cube.$('.checkout__shipping__home-delivery input[name="delivery-type"]');
          // (づ￣ ³￣)づ Ugly correction because change and click are not trigger if the shipping method is already true
          firstShippingMethod.checked = false;
          firstShippingMethod.click();
          firstShippingMethod.dispatchEvent(new CustomEvent('change'));
        }
      }
      onChangeAddress();
      initStateButtonsHandler();
    }).reload(params);
  }
};

/*
 * Creation Address
 */
function creation() {
  //Bind ignore rules from relay point when you add an address
  const form = $('#js-checkout-shipping');
  form.validate().settings.ignore = ':hidden:not(.selectpicker)';

  if(form.valid()) {
    this.disabled = true;

    cube.$id('address-book').dataset.tUrlActor = '/atg/userprofiling/ProfileActor/addShippingAddress-checkout';
    setCartridgeUrl('checkout.shipping.ch_addressbook', '/atg/userprofiling/ProfileActor/addShippingAddress-checkout', 'address-book');

    const params = getParameters(cube.$id('js-checkout-shipping'), '#home-delivery');

    cube.cartridge('address-book').after(response => {
      this.disabled = false;

      if (
        response &&
        response.responseTO &&
        response.responseTO.errors &&
        response.responseTO.errors[0].code === 'shipping.error.titleAlreadyUsed'
      ) {
        validator.showErrors({
          'title': window.Messages('shipping.error.titleAlreadyUsed')
        });
      }


      if (typeof response === 'object') return;

      sucessMessage();
      changeDelegation();
      removeDelegation();
      backDelegation();
      editDelegation();


      const addresses = cube.$id('home-delivery').$$('.tr');
      const [ selectedAddress ] = addresses.filter(
        address => address.$('.address-container strong').textContent === params.title
      );

      if (selectedAddress)
        selectedAddress.$('input').dispatchEvent(new CustomEvent('click'));

    }).reload(params);
  } else {
    /* eslint-disable no-underscore-dangle */
    window.AccountUtils._displayGeneralError(window.Messages('addressbook.modifyInvalidAddress'));
  }
};

function creationDelegation(){
  const validationPluginOpts = $.validator.cubeOptions;
  $('#address-book-form').validate($.extend(null, validationPluginOpts));

  const inputText = cube.$$('#js-checkout-shipping input[type=text]');
  inputText.forEach((el) => {
    $(el).rules('add', {'emoji': true});
  });

  if(cube.$id('addShippingBtn'))
    cube.$id('addShippingBtn').addEventListener('click', creation);
};

/*
 * Geoc code Init
 */
function geoCode(){
  const countryCodeGeoId = $('#countryCodeGeoId');

  if (countryCodeGeoId.length) {
    cube.form.address.init(countryCodeGeoId.val());

    countryCodeGeoId.on('change', () => {
      cube.form.address.init(countryCodeGeoId.val());
    });
  }
};

/*
 * Hide Address Book
 */
function displayHandler(element){
  if(element.closest('.checkout__shipping__store__layout'))
    element.closest('.checkout__shipping__store__layout').classList.add('checkout__shipping__store__layout--hidden');
};

/*
 * Add New Address
 */
export function addNewAddress(event){
  event.preventDefault();

  cube.$id('address-book').removeAttribute('data-t-url-actor');

  setCartridgeUrl('checkout.shipping.ch_shippingaddress', '/content/Shared/Checkout/Shipping Content/ShippingAddress', 'address-book');

  const params = {
    selectedAddressId : addressId(),
    fromAddressBook : true
  };

  cube.cartridge('address-book').after(() => {
    creationDelegation();
    backDelegation();
    geoCode();
    if(cube.$('.dkt-block-message--visible'))
      cube.$('.dkt-block-message--visible').nextElementSibling.classList.add('hide');
  }).reload(params);
};

/*
 * Back Navigation
 */
function backDelegation(){
  if(cube.$id('backBtn')) {
    cube.$id('backBtn').addEventListener('click', choose);
  }

  if(cube.$id('bt-back-address')) {
    cube.$id('bt-back-address').addEventListener('click', event => {
      event.target.closest('#address-book').classList.add('hidden');
      if(event.target.closest('.checkout__shipping__store').$('.checkout__shipping__store__layout--hidden'))
        event.target.closest('.checkout__shipping__store').$('.checkout__shipping__store__layout--hidden').classList.remove('checkout__shipping__store__layout--hidden');
      if(cube.$('.add-item') && cube.$('.add-item').classList.contains('hide'))
        cube.$('.add-item').classList.remove('hide');
      if(event.target.closest('.checkout__shipping__store').$('.checkout__shipping__store__layout').classList.contains('hide'))
        cube.$('.checkout__shipping__store__layout.hide').classList.remove('hide');
    });
  }
};

/*
 * Success Handler
 */
function sucessMessage(){
  cube.alert.success(window.Messages('profile.changesSaved'));
};

/*
 * Error Handler
 */
function errorHandler(response, input){
  const inpt = input;
  if(response.responseTO && response.responseTO.errors[0] && response.responseTO.errors[0].message) {
    errorMessage(response.responseTO.errors[0].message);
  } else {
    if(inpt && inpt !== '') {
      inpt.disabled = true;
    }
    sucessMessage();
  }
};

function errorMessage(response){
  const message = response;
  cube.alert.error(message);
  /*
  $('body').attr('data-new-address', 'true');
  */
};

function onChangeAddress() {
  bindPannel();
  inputReexListener();
  chooseDelegation();
  editDelegation();
  preferDelegation();
  cube.$('.checkout__shipping__home-delivery').classList.add('checkout__shipping__wrapper--deployed', 'checkout__shipping__wrapper--selected');
}


/*
 * Init Address Book
 */
function addressBook(){
  chooseDelegation();
  editDelegation();
  preferDelegation();
};

export { addressBook };



// WEBPACK FOOTER //
// ./src/modules-es5/checkout/shipping/shipping-address-book.js